import 'js/sso.js';
import '../ejs/sso.ejs';



// WEBPACK FOOTER //
// ./entry/sso_script.entry.js